import React from 'react';
import { getPerformanceLevel } from '../../utils/resultSummary';
import './ResultSummary.css';

// A mesma paleta boa/média/baixa usada nas barras de "Meu desempenho" (MyMocksPage.css)
// é good/medium/low; as barras compartilhadas (.stat-bar-fill) esperam low/medium/high.
const BAR_CLASS_BY_LEVEL = { good: 'high', medium: 'medium', low: 'low' };

function ResultSummary({ summary, description = 'Veja quantos acertos você teve em cada área do simulado.' }) {
  const { bySubject, overall } = summary;

  if (!bySubject.length) {
    return null;
  }

  return (
    <section className="result-summary dark-panel-card" aria-label="Desempenho por matéria">
      <h2>Desempenho por matéria</h2>
      <p className="material-description">{description}</p>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-card-label">Aproveitamento geral</div>
          <div className="stat-card-value">{overall.percentage}%</div>
        </div>
        <div className="stat-card">
          <div className="stat-card-label">Acertos</div>
          <div className="stat-card-value">{overall.correct}/{overall.total}</div>
        </div>
      </div>

      <div className="stats-panels">
        <div className="stats-panel">
          <h3>Por matéria</h3>
          <div className="stat-list">
            {bySubject.map((subject) => {
              const barClass = BAR_CLASS_BY_LEVEL[getPerformanceLevel(subject.percentage)];
              return (
                <div key={subject.subjectName} className="stat-item">
                  <div className="stat-header">
                    <span>{subject.subjectName}</span>
                    <strong>{subject.percentage}%</strong>
                  </div>
                  <div className="stat-bar-track">
                    <div
                      className={`stat-bar-fill ${barClass}`}
                      style={{ width: `${Math.min(subject.percentage, 100)}%` }}
                    />
                  </div>
                  <small>{subject.correct} de {subject.total} questões corretas</small>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ResultSummary;
